{
  "COMMON": {
    "ACTION_LABELS": {
      "LOAD_MORE": "Load More",
      "ADD": "Add",
      "CONFIRM": "Confirm",
      "CANCEL": "Cancel",
      "CLOSE": "Close",
      "NEXT": "Next",
      "BACK": "Back",
      "DELETE": "Delete",
      "EDIT": "Edit",
      "SAVE": "Save",
      "VIEW": "View",
      "SEARCH": "Search",
      "SEND": "Send",
      "DOWNLOAD": "Download",
      "CREATE": "Create"
    },
    "FIELD_LABELS": {
      "FIRST_NAME": "First Name",
      "LAST_NAME": "Last Name",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Phone Number",
      "ADDRESS": "Address",
      "CITY": "City",
      "STATE": "State",
      "COUNTRY": "Country",
      "PHONE": "Phone",
      "EMPLOYEE_FIRST_NAME": "Employee First Name",
      "EMPLOYEE_LAST_NAME": "Employee Last Name",
      "TEMPLATE": "Template"
    },
    "DATE_RANGE": "Date range",
    "DATE_RANGES": {
      "LAST_7_DAYS": "Last 7 days",
      "LAST_30_DAYS": "Last 30 days",
      "LAST_60_DAYS": "Last 60 days",
      "LAST_90_DAYS": "Last 90 days",
      "LAST_6_MONTHS": "Last 6 months",
      "LAST_12_MONTHS": "Last 12 months",
      "LAST_16_MONTHS": "Last 16 months",
      "CUSTOM": "Custom",
      "ALL_TIME": "All time"
    },
    "MESSAGE_TYPE": {
      "SMS_AND_EMAIL": "SMS & Email",
      "EMAIL": "Email",
      "SMS": "SMS"
    },
    "POWERED_BY": "Powered by",
    "POWERED_BY_PARTNER": "Powered by <b>{{ partnerName }}</b>",
    "VALIDATIONS": {
      "REQUIRED": "Required",
      "INVALID_EMAIL": "Invalid Email",
      "INVALID_PHONE_NUMBER": "Invalid Phone Number",
      "INVALID_ZIP_CODE": "Invalid ZIP Code",
      "INVALID_URL": "Invalid URL",
      "VALIDATION_ERRORS": "There are some validation errors."
    },
    "HELP": "Help"
  },
  "FIELD_LABELS": {
    "EMPLOYEE_FIRST_NAME": "Employee First Name",
    "EMPLOYEE_LAST_NAME": "Employee Last Name",
    "TAG": "Tag"
  },
  "APP_NAME": "Customer Voice",
  "OVERVIEW": {
    "TITLE": "Overview",
    "EMAIL_USAGE": {
      "TITLE": "Email Monthly Usage",
      "UPGRADE": "Upgrade"
    },
    "SMS_USAGE": {
      "TITLE": "SMS usage",
      "SENT_TODAY": "Sent today",
      "CREDITS_USED": "Credits used",
      "TOOLTIP": "Your daily limit of SMS requests is 150 to avoid being flagged as spam"
    },
    "REQUEST_REVIEWS": {
      "HEADER": "Request Reviews",
      "PRESCRIPTION": "Send Email or SMS review requests to improve review scores, boost SEO rankings, and build credibility."
    },
    "RECENT_REQUESTS": {
      "TITLE": "Recent requests",
      "VIEW_CUSTOMERS": "View customers",
      "CUSTOMER_DELETED": "Customer has been deleted",
      "EMPTY_STATE_TITLE": "No recent requests",
      "SEND_REVIEW_REQUEST": "Send a review request",
      "SINGLE_EMAIL": "Email sent to {{customerName}}",
      "SINGLE_SMS": "SMS sent to {{customerName}}",
      "BULK_EMAIL_PREFIX": "Bulk email sent to {{eventCount}} customers",
      "BULK_SMS_PREFIX": "Bulk SMS sent to {{eventCount}} customers",
      "BULK_POSTFIX": " customers"
    },
    "PERFORMANCE_GRAPHS": {
      "REQUEST_PERFORMANCE": "Request Performance",
      "SENDS": "Sent",
      "OPENS": "Opened",
      "CLICKS": "Clicked",
      "ALL_TIME": "All-Time",
      "REVIEW_STATS": "New Reviews",
      "NO_DATA": "No data",
      "NO_DATA_ALL_TIME": "No data for this <br>date range",
      "EMAIL_ONLY": "Email only"
    }
  },
  "CUSTOMERS": {
    "TITLE": "Customers",
    "HEADER": "Manage Customers",
    "SUPER_TABLE": {
      "LABELS": {
        "NO_RESULTS": "No Results",
        "CANCEL": "Cancel",
        "NONE": "None",
        "UPDATE": "Update",
        "SORT_BY": "Sort By",
        "THEN_SORT_BY": "Then Sort By",
        "ADD_ANOTHER_SORT_COLUMN": "Add another sort column",
        "CHOOSE_COLUMN_TO_SORT_BY": "Choose a column to sort by",
        "COLUMN_SORTING": {
          "DATE": {
            "ASCENDING": "Earliest to latest",
            "DESCENDING": "Latest to earliest"
          },
          "NUMBER": {
            "ASCENDING": "1 to 9",
            "DESCENDING": "9 to 1"
          },
          "STRING": {
            "ASCENDING": "A to Z",
            "DESCENDING": "Z to A"
          },
          "DEFAULT": {
            "ASCENDING": "Ascending",
            "DESCENDING": "Descending"
          }
        },
        "EXPORT": {
          "BUTTON_TEXT": "Export",
          "BUTTON_TOOLTIP_BEFORE_COUNT": "Export",
          "BUTTON_TOOLTIP_AFTER_COUNT": "Items"
        },
        "COLUMN_SELECTOR": {
          "BUTTON_TEXT": "Columns"
        }
      },
      "FILTERS": {
        "TITLE": "Filters",
        "EMAIL_STATUS": "Email Status",
        "SMS_STATUS": "SMS Status",
        "LAST_REQUESTED_DATE": "Last Requested Date",
        "CREATED_DATE": "Created Date ",
        "FROM": "From",
        "TO": "To",
        "TAG": "Tags",
        "TAG_PLACEHOLDER": "Select Tag",
        "CREATED_FROM": "Created From",
        "CREATED_TO": "Created To",
        "REQUESTED_FROM": "Requested From",
        "REQUESTED_TO": "Requested To",
        "EXCLUDE_TAGS": "Exclude tag(s)",
        "CUSTOMER_RECENT_REQUEST": "Recent Request"
      },
      "COLUMNS": {
        "CUSTOMER_FIRST_NAME": "First Name",
        "CUSTOMER_LAST_NAME": "Last Name",
        "EMPLOYEE_NAME": "Employee",
        "CONTACT_INFO": "Contact",
        "LAST_REQUESTED": "Last Requested",
        "REQUEST_STATUS": "Status",
        "CREATED_ON": "Created",
        "TAG": "Tag",
        "ORIGIN": "Source",
        "STATUS": {
          "SENDING": "Sending...",
          "SENT": "Sent",
          "OPENED": "Opened",
          "CLICKED": "Clicked",
          "COMPLETE": "Review Complete",
          "UNSUBSCRIBED": "Unsubscribed",
          "BOUNCED": "Bounced",
          "SPAM": "Reported as Spam",
          "DROPPED": "Dropped",
          "POSITIVE": "Clicked - Positive",
          "NEGATIVE": "Clicked - Negative",
          "NOT_SENT": "Not Sent",
          "LEFT_REVIEW": "Review Completed (Star Rating: {{starRating}})",
          "REVIEW_LEFT": "Review Completed",
          "DEFERRED": "Deferred"
        },
        "SMS_ERROR_MESSAGES": {
          "QUEUE_FULL": "Message queue full - You’ve sent too many messages at once and your queue is full. Try waiting a while and sending again.",
          "ACCOUNT_SUSPENDED": "Account suspended - Your account has been suspended. Please contact us.",
          "UNREACHABLE_DESTINATION": "Unreachable destination - The cell phone associated with this number is switched off or unavailable.",
          "MESSAGE_BLOCKED": "Message blocked - This number is blocked from receiving your message.",
          "UNKNOWN_DESTINATION": "Unknown destination - This number is unknown and may no longer exist.",
          "LANDLINE_NUMBER": "Landline number - This is a landline number and is unable to receive your text message.",
          "CARRIER_VIOLATION": "Carrier violation - Your message was flagged by the carrier. This can happen because of things like spam filtering.",
          "UNKNOWN_ERROR": "Unknown error - Your message wasn’t delivered due to an unknown error. Please try again.",
          "UNSUBSCRIBED": "Unsubscribed - You are attempting to send a message to a number that has opted out of receiving messages using a STOP keyword."
        },
        "DROPDOWN_MENU": {
          "EDIT_CUSTOMER": "Edit customer",
          "DELETE_CUSTOMER": "Delete customer"
        }
      }
    },
    "ACTION_BUTTON": {
      "TITLE": "Actions",
      "SEND_EMAIL": "Send Email",
      "DELETE_SELECTED": "Delete",
      "DELETE_SUCCESS": "Customer(s) successfully deleted.",
      "DELETE_ERROR": "Error trying to delete customer(s).",
      "SEND_REQUEST": "Send request",
      "SEND_REVIEW_REQUEST": "Send Review Request"
    },
    "CREATE_CUSTOMER_DIALOG": {
      "TITLE": "Create Customer"
    },
    "PREVIEW_EMAIL": {
      "SELECT_TEMPLATE": "Select Template",
      "PREVIEW_TEMPLATE": "Preview",
      "SEND_EMAILS": "Send To {{number}} Customers",
      "CUSTOMER_MISSING": "{{missing}} of {{selected}} customers missing {{type}}",
      "EMAIL_SEND_SUCCESS": "Email(s) sent",
      "SMS_SEND_SUCCESS": "SMS sent",
      "NO_BULK_FOR_GF_ERROR": "Sending multiple SMS unavailable with your current version of {{appName}}",
      "NO_EMAIL_FOR_EXPRESS_ERROR": "You have no email credits left.",
      "UPGRADE": "Upgrade to Add more"
    },
    "PREVIEW_PAGE": {
      "TITLE": "Send Review Request"
    },
    "SEND_EMAILS_BUTTON": "Send {{number}} Email(s)",
    "PREVIEW_SEND_SMS": "Preview & Send SMS",
    "SEND_SMS_BUTTON": "Send {{number}} SMS Message(s)",
    "NO_EMAIL_EVENTS_FOR_CUSTOMER": "No Email History found for customer",
    "EMAIL_HISTORY": "Email History"
  },
  "TEMPLATES": {
    "TITLE": "Templates",
    "REVIEW_REQUEST_EMAIL": "Review Request Email",
    "REVIEW_REQUEST_SMS": "Review Request SMS",
    "DEFAULT": "Default",
    "EDIT_TEMPLATE": "Edit Template",
    "MAKE_DEFAULT_TEMPLATE": "Make Default Template",
    "DELETE_TEMPLATE": "Delete Template",
    "PREVIEW_BUTTON": "Preview",
    "DELETE_TEMPLATE_SUCCESS": "Template deleted",
    "DELETE_TEMPLATE_ERROR": "Unable to delete template",
    "ADD_NEW_TEMPLATE": "Add New Template",
    "ADD_NEW_TEMPLATE_EMAIL": "New Email Template",
    "ADD_NEW_TEMPLATE_SMS": "New SMS Template",
    "ADD_NEW_TEMPLATE_ERROR": "Unable to create template",
    "CHANGE_TEMPLATE_TYPE_DIALOG": {
      "TITLE": "Change email template type",
      "PLACEHOLDER_TEXT": "Select a template type",
      "WARNING": "Changing the email template type will update and replace all email content.",
      "MY_LISTING": "My Listing",
      "THIRD_PARTY": "Third Party",
      "BLANK": "Blank Template",
      "CUSTOM": "Custom Site",
      "CHANGE_TEMPLATE_TYPE_SUCCESS": "Template type successfully changed",
      "CHANGE_TEMPLATE_TYPE_ERROR": "Unable to change template type"
    },
    "NEW_TEMPLATE_DIALOG": {
      "TITLE": "New Template",
      "PLACEHOLDER": "Template Name",
      "EMAIL_TEMPLATES": "Email Defaults",
      "SMS_TEMPLATES": "SMS Defaults",
      "NEW_MY_LISTING_TEMPLATE_HEADER": "New My Listing Template",
      "NEW_MY_LISTING_TEMPLATE_DESCRIPTION": "Create a template that will direct recipients to leave a review on your My Listing.",
      "NEW_PREFERRED_SITES_TEMPLATE_HEADER": "New Preferred Review Sites Template",
      "NEW_PREFERRED_SITES_TEMPLATE_DESCRIPTION": "Create a template that will direct recipients to leave a review on your preferred review sites.",
      "NEW_CUSTOM_SITE_TEMPLATE_HEADER": "New Custom Site Template",
      "NEW_CUSTOM_SITE_TEMPLATE_DESCRIPTION": "Create a template that will direct recipients to site of your choosing",
      "NEW_BLANK_TEMPLATE_HEADER": "New Blank Template",
      "NEW_BLANK_TEMPLATE_DESCRIPTION": "Create an empty template to customize with your own content."
    },
    "UPDATE_TEMPLATE_SUCCESS": "Template updated",
    "UPDATE_TEMPLATE_ERROR": "Unable to update template",
    "TEMPLATE_NAME": "Template Name",
    "SMS_CONTENT": "SMS Content",
    "TEMPLATE_TYPE": "Template Type",
    "TEMPLATE_DISABLED_REASON_EMAIL": "No contacts with emails selected",
    "TEMPLATE_DISABLED_REASON_SMS": "No contacts with phone numbers selected",
    "SHORTENED_BUSINESS_NAME": "Shortened Business Name",
    "SMS_GREETING": "SMS Greeting",
    "SMS_GREETINGS": {
      "HI": "Hi",
      "HELLO": "Hello",
      "HEY": "Hey",
      "HEY_THERE": "Hey there",
      "HI_CUSTOMER": "Hi [Customer First Name]",
      "HELLO_CUSTOMER": "Hello [Customer First Name]",
      "HEY_CUSTOMER": "Hey [Customer First Name]"
    },
    "NAME_DROP": "Customer's name will be dropped from SMS.",
    "SMS_GREETING_HINT": "Customer first names longer than {{number}} character(s) will be dropped from SMS.",
    "SMS_COMPANY_NAME_HINT": "Due to limited character count - enter a shorter Business Name for SMS review requests.",
    "SMS_MESSAGE": "SMS Message",
    "MESSAGE_TOO_LONG": "Can't save: The SMS Message is too long.",
    "MESSAGE_REQUIRED": "Can't save: The SMS Message is required.",
    "PREFERRED_REVIEW_SITES": "Preferred Review Sites",
    "MY_LISTING": "My Listing",
    "CUSTOM_SITE": "Custom site",
    "DEFAULT_TEMPLATE_SAVE": {
      "SUCCESS": "Default template successfully saved",
      "ERROR": "Error saving default template"
    },
    "SMS_CUSTOM_URL": {
      "CUSTOM_URL": "Custom Link",
      "CUSTOM_URL_DISABLED": "Can not use custom link with this template type",
      "CUSTOM_URL_HINT": "Custom link will be shortened for SMS",
      "TRACKING_WARNING_HINT": "Clicks on custom links are not tracked",
      "CUSTOM_URL_REQUIRED": "Can't save: The custom link is required"
    },
    "SMS_TOO_LONG": "<strong>SMS length exceeds maximum allowed characters.</strong> Add a shortened business name or shorten the message to save changes."
  },
  "REQUEST_REVIEWS_BUTTON": {
    "TITLE": "Request Reviews",
    "ADD_CUSTOMER_SMS": "Add Customer & Send SMS ({{smsUsage}}/{{smsLimit}} Sent)",
    "ADD_CUSTOMER_EMAIL": "Add Customer & Send Email",
    "BULK_ADD_CUSTOMERS": "Bulk Add Customers",
    "BULK_ADD_CUSTOMERS_AND_SEND": "Bulk Add Customers & Send Requests"
  },
  "WIDGET": {
    "TITLE": "Tools",
    "WIDGETS": "Widgets",
    "PRESCRIPTION": "Embed the Review Generation Widget anywhere on your website to conveniently collect reviews from customers. Simply customize the widget below, then copy and paste the code into the HTML of your desired website.",
    "WIDGET_SETUP": "Widget Setup",
    "WIDGET_CODE": "Widget Code",
    "WIDGET_PREVIEW": "Widget Preview",
    "COPY_WIDGET_CODE": "Copy widget code",
    "EMAIL_SIGNATURE": {
      "CARD_TITLE": "Email Signature Widget",
      "CARD_HINT": "Where do you want to collect reviews?",
      "MY_LISTING": "My Listing",
      "PREFERRED_SOURCES": "Preferred Sources",
      "RATING_QUESTION": "How did we do?",
      "RATING_LINK": "Click to rate your experience with {{businessName}}",
      "COPY_BUTTON": "Copy email signature widget"
    },
    "SETTINGS": {
      "BACKGROUND_COLOR": "Background Color",
      "PRIMARY_TEXT_COLOR": "Primary Text Color",
      "SECONDARY_TEXT_COLOR": "Secondary Text Color",
      "TEXT_FONT": "Text Font"
    },
    "KIOSK": {
      "TITLE": "Mobile Kiosk",
      "CARD_HEADER": "Mobile Kiosk URL",
      "DESCRIPTION": "Copy the URL below to your web browser, no password or login required",
      "HINT": "<b>What’s this?</b> Show your customers a simple form to submit their contact information during checkout or at the end of your service. {{appName}} will automatically send a review request to your customer—no login required! Simply paste the URL into a browser on your phone or tablet, and hand your device to your customer to get started."
    }
  },
  "SETTINGS": {
    "TITLE": "Settings",
    "SAVE": "Save",
    "COPY_TEMPLATE_ID": "Copy Template ID",
    "PREVIEW_BUTTON": "Preview",
    "CANCEL": "Cancel",
    "RESTORE_TO_DEFAULTS": "Restore to Default",
    "SAVE_AND_PREVIEW": "Save & Preview",
    "PREVIEW": {
      "TITLE": "Preview Template",
      "CLOSE": "Close"
    },
    "PREFERRED_REVIEW_SITES": {
      "TITLE": "Preferred Review Sites",
      "HEADER": "Preferred Review Sites",
      "PRESCRIPTION": "Select the sites that you’d prefer to generate more reviews on, paste in the appropriate link, and drag and drop into priority order.",
      "MANUALLY_OVERRIDDEN": "Manually Overridden",
      "MANUALLY_ENTERED": "Manually Entered",
      "NOT_FOUND": "Not Found",
      "LISTING_FOUND_WITH_ERRORS": "Listing Found with Errors",
      "ACCURATE_LISTING": "Accurate Listing",
      "OVERRIDE_REVIEW_URL": "Override Review URL",
      "ENTER_REVIEW_URL": "Enter Review URL",
      "INVALID_SOURCE": "Invalid {{sourceName}} Url",
      "TOO_MANY_SOURCES": "Can only select up to 3 review sources",
      "SUCCESS": "Saving successful",
      "ERROR": "Saving failed, some urls are invalid",
      "SEND_TO_GOOGLE_TEXT": "If a customer has a Gmail account, automatically send them to Google to leave a review, regardless of the settings above.",
      "ERROR_SAVING_GOOGLE_SETTING": "An error occurred saving the 'Send to Google' setting",
      "SEND_TO_GOOGLE_DESCRIPTION_TEXT": "If a customer has a Gmail or G Suite account, there’s a chance that they’re already logged into Google. Sending customers to a site they’re already logged into increases the likelihood of them leaving a review.",
      "SEND_TO_GOOGLE_HEADER": "Google Review Prioritization",
      "LEGAL_SOURCE_USE": "All product and company names, logos, brands are trademarks or registered trademarks of their respective holders. Use of them is for identification or reference purposes only and does not imply any affiliation, association, or endorsement by them."
    },
    "TEMPLATE_EDITOR": {
      "FOOTER_LANGUAGES": {
        "ENGLISH": "English",
        "FRENCH": "French"
      }
    },
    "EMAIL_SETTINGS": {
      "TITLE": "Email Settings",
      "HEADER": "Select Email Workflow & Customize Content",
      "CURRENTLY_ACTIVE": "Currently Active",
      "ACTIVE_DESCRIPTION": "This workflow will be used for all email review requests.",
      "EMAIL_CONTENT": "Customize Email Content",
      "FOLLOW_UP_CONTENT": "Customize Email Content (Positive Review Follow-Up)",
      "FOLLOW_UP_DESCRIPTION": "If a customer leaves a 4+ star rating with content on your My Listing page, they’ll be asked to share it on your preferred review sites. If they don’t, the system will send them this email as a reminder 2 hours later.",
      "USE_THIS_WORKFLOW": "Use This Workflow",
      "SUCCESS": "Email workflow saving successful",
      "ERROR": "Error saving email workflow",
      "EXCEED_CONTENT_LIMIT_ERROR": "Whoops! The character limit for this email template has exceeded the maximum of 32,000 characters. Please update the template by reducing the amount of characters used and try again.",
      "FIRST_PARTY_WORKFLOW": {
        "TITLE": "1st Party Workflow",
        "HEADER": "Collect 1st party reviews on \"My Listing\"",
        "DESCRIPTION_PART_ONE": "1st party reviews are collected by your business, on your ",
        "DESCRIPTION_PART_TWO": " page. These reviews are owned by your business and can be used and distributed any way you want.",
        "ALT_TEXT": "Email First Party Workflow Description",
        "MY_LISTING": "\"My Listing\""
      },
      "THIRD_PARTY_WORKFLOW": {
        "TITLE": "3rd Party Workflow",
        "HEADER": "Collect 3rd party reviews on \"My Preferred Review Sites\"",
        "DESCRIPTION": "3rd party reviews are collected on external websites like Facebook, Google, etc., and are not owned by your business. That means the collection and distribution of these reviews must comply with the 3rd party’s terms of service.",
        "ALT_TEXT": "Email Third Party Workflow Description"
      },
      "CONTENT_FORM": {
        "TITLE_EDITOR_PLACEHOLDER": "Template name",
        "TOOLTIP": "What's this?",
        "EMAIL_SUBJECT_AND_SENDER": "Email Subject & Sender",
        "EMAIL_FOOTER": "Email Footer",
        "DISPLAY_EMAIL_FOOTER": "Display language in:",
        "DISPLAY_EMAIL_FOOTER_ENGLISH": "English",
        "DISPLAY_EMAIL_FOOTER_FRENCH": "French",
        "EMAIL_SUBJECT": "Email Subject",
        "SEND_FROM_EMAIL": "Send from email",
        "SETUP_SEND_FROM_EMAIL": "Setup <b>Send from email</b>",
        "EDIT_SEND_FROM_EMAIL": "Edit <b>Send from email</b>",
        "UPGRADE_TO_PRO": "Upgrade to pro",
        "TO_SETUP_SEND_FROM_EMAIL": "to setup <b>Send from email</b>",
        "REPLY_TO_EMAIL": "Reply Email",
        "EMAIL_CONTENT": "Email Content",
        "HEADER": "Header",
        "EDIT_HEADER": "Edit Header",
        "DELETE_HEADER": "Delete Header",
        "UPLOAD_EMAIL_HEADER": "Select Or Upload Email Header",
        "EMAIL_TITLE": "Email Title",
        "EMAIL_GREETING": "Email Greeting",
        "TITLE_FONT": "Title Font",
        "MESSAGE": "Message",
        "GREETING_AND_MESSAGE_FONT": "Greeting & Message Font",
        "BUTTON_TEXT": "Button Text",
        "BUTTON_COLOR": "Button Color",
        "BUTTON_URL": "Button URL",
        "CLOSING_MESSAGE": "Closing Message (Optional)",
        "LOGO": "Logo",
        "LOGO_DIMENSIONS": "Recommended dimensions 280x44 px",
        "SUCCESS": "Settings successfully saved",
        "ERROR": "There was an error saving your settings",
        "REQUIRED": "Required",
        "INCLUDE_DIRECT_FEEDBACK_OPTION": "Ask for direct feedback from customers",
        "DIRECT_FEEDBACK_HELPER_TEXT": "Include an option for customers to contact you directly through your My Listing page. This gives them an opportunity to give constructive feedback they may not want to leave on a public review site.",
        "DIRECT_FEEDBACK_MESSAGE": "Message (Optional)",
        "REPLY_TO_TOOLTIP": "If a customer replies to your email, it will be sent to this address.",
        "BUTTON_URL_TOOLTIP": "If you leave this blank it will redirect to your review page.",
        "DEFAULT_FONT_HELP_TEXT": "Custom fonts are not supported by all email clients. If the selected font isn't supported, their default font will be used."
      },
      "UPLOAD_HEADER_IMAGE": {
        "HEADER": "Upload Header Image",
        "SELECT_FROM_PHOTO_LIBRARY": "Select from Photo Library",
        "UPLOAD_CUSTOM_PHOTO": "Upload Custom Photo",
        "HEADER_DIMENSIONS": "Recommended dimensions 700x235 px",
        "FILE_TYPES": "File Types: JPG, PNG Max Size: 5MB"
      }
    },
    "TEMPLATE_SETTINGS": {
      "CHANGE_TEMPLATE_TYPE": "Change Template Type",
      "CREATE_TEMPLATE": "Create Template",
      "DELETE_TEMPLATE_BUTTON": "Delete",
      "DYNAMIC_COMPONENTS": "Insert Dynamic Component",
      "LOADING_FAILURE": "Failed to load template.",
      "SAVING_FAILURE": "Failed to save template. Title, subject and content is required.",
      "PREVIEW_FAILURE": "Failed to load preview",
      "PREVIEW_FAILURE_INVALID_CONTENT": "There’s an error with the content in your template. Check that the Dynamic Components are correct and try loading the preview again.",
      "PREVIEW_FAILURE_MISSING_FIELDS": "Failed to load preview. Title, subject and content is required.",
      "CHOOSE_TEMPLATE": "Choose Template",
      "FOLLOW_UP_PANEL_HEADER": "Edit Follow Up Email"
    },
    "CONFIRMATION_MESSAGES": {
      "TITLE": "Confirmation Messages",
      "HEADER": "Review Confirmation Message",
      "PRESCRIPTION": "Enter the response you’d like your customers to see after they leave a review on My Listing or the Review Generation widget.",
      "POSITIVE_REVIEW_MESSAGE": "Positive Review Message",
      "NEGATIVE_REVIEW_MESSAGE": "Negative Review Message",
      "SUCCESS": "Confirmation messages successfully saved",
      "ERROR": "Error while saving confirmation messages.",
      "POSITIVE_MESSAGE_REQUIRED": "Positive message is required",
      "NEGATIVE_MESSAGE_REQUIRED": "Negative message is required"
    },
    "REVIEW_PAGE_URLS": {
      "TITLE": "Review Page URLs",
      "MY_LISTING_DESCRIPTION": "Below is the direct URL to your My Listing page.",
      "MY_LISTING_CARD_HEADER": "\"My Listing\" - Leave a Review Page",
      "CUSTOMER_DRIVEN_CARD_HEADER": "Customer-Driven Review Generation",
      "COPY_TO_CLIPBOARD": "Copy to Clipboard"
    },
    "SMS_CONFIGURATION": {
      "TITLE": "SMS Configuration"
    }
  },
  "NAVBAR": {
    "EMAIL_USAGE": {
      "MONTHLY_USAGE": "Monthly Usage",
      "UPGRADE": "Upgrade"
    },
    "SMS_USAGE": {
      "SMS_SENT": "SMS Sent",
      "TOTAL": "total",
      "TODAY": "today"
    }
  },
  "PREVIEW_SMS": {
    "PREVIEW_PRESCRIPTION": "Please note that the daily limit for sending SMS is 150 messages. You have sent {{dailyUsage}} today. You have sent {{usage}} out of {{limit}} SMS review requests this month.",
    "BULK_SMS_WARNING": "When bulk sending a large amount of SMS review requests this action may take several minutes to complete."
  },
  "ADD_CUSTOMER_FORM": {
    "SINGLE_SMS": "Add Customer & Send SMS",
    "SINGLE_EMAIL": "Add Customer & Send Email",
    "BULK_ADD": "Bulk Add Customers",
    "BULK_EMAIL": "Bulk Add Customers & Send Emails",
    "IMPORT_CUSTOMERS": "Import Customers",
    "BULK_SMS": "Bulk Add Customers & Send SMS",
    "SEND_REQUEST_TO": "Send Request To",
    "SEND_REQUEST_FROM": "Employee Requesting Review",
    "FIRST_NAME": "First Name",
    "LAST_NAME": "Last Name",
    "INVALID_CHARACTERS": "Invalid character(s)",
    "INVALID_FIELDS": "Some fields are invalid",
    "INVALID_EMAIL_ADDRESS": "Invalid email address",
    "INVALID_PHONE_NUMBER": "Invalid phone number",
    "EMAIL_ALREADY_EXISTS": "Email address already exists",
    "EMAIL_ALREADY_EXISTS_WITH_LINK": "A customer with this email already exists.",
    "PHONE_ALREADY_EXISTS": "Phone number already exists",
    "PHONE_ALREADY_EXISTS_WITH_LINK": "A customer with this phone number already exists.",
    "GO_TO_CUSTOMERS_LINK": "Go to Customers",
    "EMAIL_REQUIRED": "Email address required",
    "EMAIL_REQUIRED_FOR_TEMPLATE": "Enter email address to select a template",
    "EMAIL_OR_PHONE_REQUIRED_FOR_TEMPLATE": "Enter email address or phone number to select a template",
    "EMAIL": "Email",
    "CELL_PHONE": "Cell Phone",
    "TAG": "Tag",
    "ADD_CUSTOMER": "Add Customer",
    "ADD_CUSTOMERS": "Add Customers",
    "EDIT_CUSTOMER": "Edit Customer",
    "ADD_MULTIPLE_CUSTOMERS": "Add Multiple Customers",
    "UPLOAD_BULK_SMS_DELAY_WARNING": "When bulk uploading and sending large csv files, this action may take several minutes to complete sending all requests.",
    "UPLOAD_SMS_DAILY_LIMIT_WARNING": "To avoid being flagged as spam by carriers, <strong>the limit for sending text messages is 150 per day.</strong>",
    "UPLOAD_SMS_DAILY_USAGE": "You have sent {{dailyUsage}} today",
    "MAP_FIELDS": "Map Fields",
    "PREVIEW_AND_SEND": "Preview & Send",
    "NEXT": "Next",
    "PREVIOUS": "Previous",
    "SAVE_AND_SEND_LATER": "Save & Send Later",
    "SAVE_AND_CONTINUE": "Save & Continue",
    "SEND_REQUEST_LATER": "Send Request Later",
    "SEND": "Send",
    "UPLOAD": "Upload",
    "UPLOAD_AND_SEND": "Upload and Send",
    "UPLOAD_CSV_FILE": "Choose File",
    "UPLOAD_DESCRIPTION": "Upload up to 500 customers per file. The following column titles are allowed: First Name, Last Name, Email, Phone, Employee First Name, Employee Last Name, and Tag.  Use this <a href=\"https://storage.googleapis.com/cv-customers-csv/important/sample-create-customers-template.csv\" download=\"create-customers-template.csv\">template</a>.",
    "AN_ERROR_OCCURRED": "An error occurred",
    "EMAIL_OR_PHONE_MISSING": "New customer must have email address or phone number",
    "CUSTOMER_ADDED": "Customer has been saved",
    "CUSTOMER_UPDATED": "Customer has been updated",
    "CUSTOMER_ALREADY_EXISTS": "Customer already exists",
    "SOMETHING_WENT_WRONG_SENDING_SMS": "Something went wrong sending SMS.",
    "SOMETHING_WENT_WRONG_SENDING_EMAIL": "Something went wrong sending the emails",
    "CUSTOMIZE_TEMPLATE": "Customize Template",
    "MAP_CSV": {
      "MAP_CSV_FIELDS": "Map CSV Fields",
      "MAPPING_DESCRIPTION": "Map your CSV columns to their corresponding fields. Header Row and First Row reflect what's in your CSV file. Use the Mapping dropdown to select which attribute the column is associated with.",
      "MAPPING_DESCRIPTION_SMS": "Map your CSV columns to their corresponding fields. <strong>Header Row</strong> and <strong>First Row</strong> reflect what's in your CSV file. Use the <strong>Mapping dropdown</strong> to select which attribute the column is associated with. The <strong>Phone Number<sup>*</sup></strong> field is required.",
      "DROP_FILES_HERE": "Drag and drop a .CSV file here or",
      "HEADER_ROW": "Header Row",
      "FIRST_ROW": "First Row",
      "MAPPING": "Mapping",
      "DO_NOT_IMPORT": "Do Not Import",
      "NO_EMAIL_OR_PHONE_ERROR": "You must include an email address or a phone number field",
      "MULTIPLE_MAPPING_ERROR": "You may not map multiple columns to the same field",
      "ROW": "Row",
      "ERROR": "Error",
      "VALIDATION_ERRORS": "There is {{errorNumber}} row(s) with errors in your CSV. Please address these errors and upload the file again.",
      "OVER_500_ERROR": "You may only upload up to 500 customers at one time. Please reduce the number of rows in your CSV file.",
      "NO_CUSTOMERS_ADDED": "No customers have been added.",
      "EMAIL_OR_PHONE_REQUIRED": "Either email address or phone number is required",
      "INVALID_EMAIL": "Invalid or missing email address",
      "INVALID_PHONE": "Invalid phone number",
      "INVALID_FIRST_NAME": "First name cannot include ',' or ';'",
      "INVALID_LAST_NAME": "Last name cannot include ',' or ';'",
      "ADD_CUSTOMERS_ERROR": "An error occurred while adding customers",
      "NOT_A_CSV_FILE": "Not a CSV file",
      "CSV_FILE_IS_EMPTY": "CSV file is empty",
      "SMS_DAILY_LIMIT_ERROR": "You do not have enough daily limit remaining to send the sms requests",
      "SMS_MONTHLY_LIMIT_ERROR": "You do not have enough monthly limit remaining to send the sms requests",
      "AT_LEAST_ONE_CUSTOMER_DOESNT_HAVE_VALID_PHONE": "At least one customer does not have a valid phone number"
    }
  },
  "EDIT_CUSTOMER_FORM": {
    "TITLE": "Edit Customer",
    "CUSTOMER_UPDATED": "Customer has been updated",
    "INVALID_FIELDS": "Some fields are invalid"
  },
  "NO_PREFERRED_SITES": {
    "TITLE": "No Preferred Sites Selected",
    "PRESCRIPTION": "You must choose at least one Preferred Site in your settings to use the third party workflow. No {{messageType}} will be sent.",
    "SELECT_PREFERRED_SITES": "Select Preferred Sites",
    "DO_IT_LATER": "Do It Later"
  },
  "COUNTRY_NAMES": {
    "CANADA": "Canada and the US",
    "US": "the USA and Canada",
    "AUSTRALIA": "Australia",
    "UK": "the United Kingdom"
  },
  "COPY_TEXT_MESSAGE": {
    "REVIEW_GEN_WIDGET": "Widget code copied to clipboard",
    "EMAIL_SIGNATURE_WIDGET": "Email signature widget copied to clipboard",
    "TEMPLATE_ID": "Template ID copied to clipboard",
    "URL": "URL copied to clipboard",
    "FAILED_TO_COPY": "Failed to copy"
  },
  "EXPRESS_CTA_DIALOG": {
    "IMAGE_TEXT": {
      "EMAIL_USAGE": "Upgrade now for unlimited emails",
      "GET_MORE": "Boost your star ratings, with trusted customer reviews",
      "TEMPLATES": "Increase customer engagement, and collect more reviews.",
      "BULK_REVIEW_REQUESTS": "Reach your customers quicker, with bulk review requests.",
      "REVIEW_SOURCES": "Become the trusted local brand. Request reviews on dependable sites.",
      "MOBILE_KIOSK": "Request feedback from your customers on-site"
    },
    "KEY_SELLING_POINTS": {
      "UNLIMITED_EMAIL": "Send unlimited emails",
      "SMS_ADDONS": "Access to SMS add-ons",
      "40_TEMPLATES": "Save up to 40 templates",
      "MORE_REVIEW_SITES": "Request reviews on 70+ sites",
      "FOLLOW_UP_EMAILS": "Auto-send follow up emails",
      "BULK_SEND": "Bulk send review requests",
      "MOBILE_KIOSK": "Collect contact information fast with Mobile Kiosk"
    },
    "ACTIVE_ORDER": {
      "HOLD_TIGHT": "Hold Tight!",
      "ON_THE_WAY": "Your upgrade is on its way."
    },
    "IMPERSONATION_FORBIDDEN": "An impersonated user cannot upgrade to Pro.",
    "UPGRADE_NOW_TEXT": "Upgrade now for only",
    "UPGRADE_STARTING_AT_TEXT": "Upgrades starting at",
    "EDITION_NAME": "Pro",
    "CTA_TEXT": "Upgrade Now!",
    "GET_MORE": "Get more out of {{appName}}",
    "GET_PRO": "Get Pro",
    "CTA_UPGRADE": "Upgrade to Pro",
    "TEMPLATES_CTA_TITLE": "Collect more reviews with tailored requests.",
    "TEMPLATES_CTA_BODY": "Invite your unique customer base to share their experiences online with up to 40 customizable templates.",
    "PREFERRED_SITES_CTA_TITLE": "Request reviews on more sites that matter.",
    "PREFERRED_SITES_CTA_BODY": "Which review sites are your potential customers looking at? Collect feedback on trusted review sites that are important to your business.",
    "WELCOME": {
      "LOCAL_EXPERT_CAPTION": "Become the trusted local expert",
      "LOCAL_EXPERT_SUB_CAPTION": "Gathering authentic reviews helps boost your online presence & reputation. Help new customers find you first and trust you as the local expert.",
      "BOOST_RATING_CAPTION": "Boost your star rating and build trust",
      "BOOST_RATING_SUB_CAPTION": "More consumers trust a business with positive online reviews. Collect valuable feedback to increase your star rating and grow your business faster.",
      "REACH_CUSTOMERS_CAPTION": "Reach your customers in an instant",
      "REACH_CUSTOMERS_SUB_CAPTION": "Request valuable feedback from your customers wherever they are. Reach them quicker with SMS or email requests.",
      "HAPPY_CUSTOMERS_CAPTION": "Happy customers earn new customers",
      "HAPPY_CUSTOMERS_SUB_CAPTION": "Leverage the voice of valued customers and grow your business. Invite them to share their experiences so new customers know you can be trusted.",
      "ADD_GOOGLE_URL": "Add Google URL",
      "ADD_FACEBOOK_URL": "Add Facebook URL",
      "FOUND_GOOGLE_URL": "Google URL Found",
      "FOUND_FACEBOOK_URL": "Facebook URL Found",
      "WELCOME_TO": "Welcome to",
      "SETUP": "Setup Review Site URLs",
      "COLLECT": "Collect Reviews on Google and Facebook!"
    },
    "CUSTOMER_BANNER": {
      "TITLE": "Want to save time by sending multiple requests?",
      "DESCRIPTION": "Reach your customers quicker and gather more valuable feedback with bulk review requests."
    }
  },
  "DISPLAY_PRICE_FREQUENCY": {
    "OTHER": "Other",
    "ONE_TIME": "One Time",
    "DAILY": "Daily",
    "DAY": "/day",
    "WEEKLY": "Weekly",
    "WEEK": "/week",
    "MONTH": "/month",
    "MONTHLY": "Monthly",
    "YEAR": "/year",
    "YEARLY": "Yearly"
  },
  "CUSTOMER_FACING_FORM": {
    "TITLE": "How did we do?",
    "DESCRIPTION": "Please take a moment to provide your contact information. We will send you a request to leave us a review.",
    "FIRST_NAME": "First Name",
    "LAST_NAME": "Last Name",
    "EMAIL_ADDRESS": "Email Address",
    "MOBILE": "Mobile",
    "CONFIRM_MESSAGE": "I am providing only my own contact information. By clicking submit, I consent to receive future emails, text messages, and/or phone calls from {{businessName}}.",
    "CONFIRM_DEFAULT_MESSAGE": "I am providing only my own contact information. By clicking submit, I consent to receive future emails, text messages, and/or phone calls.",
    "SUBMIT_BUTTON": "Submit",
    "LOADING": "Loading the Mobile Kiosk form...",
    "ERROR_LOADING_TITLE": "Oops!",
    "ERROR_LOADING_FORM": "The Mobile Kiosk form couldn't be loaded. To try again, ensure that you've copied and entered the Mobile Kiosk URL correctly.",
    "INVALID_FIRST_NAME": "Invalid first name with special characters.",
    "INVALID_LAST_NAME": "Invalid last name with special characters.",
    "FIRST_NAME_TOO_LONG": "First name is too long.",
    "LAST_NAME_TOO_LONG": "Last name is too long.",
    "REQUIRED": "Required",
    "OPTIONAL": "Optional",
    "THIS_FIELD_REQUIRED": "This field is required",
    "CONFIRM_DIALOG_TITLE": "Confirmed! We've sent it!",
    "CONFIRM_DIALOG_DESC_1": "We've sent you a review request.",
    "CONFIRM_EMAIL_DIALOG_DESC_2": "Please check your email!",
    "CONFIRM_SMS_DIALOG_DESC_2": "Please check your sms!",
    "CONFIRM_DIALOG_BUTTON": "Done",
    "ERROR_SUBMITTING_FORM": "Error submitting form, please try again."
  }
}
